import { MenuItem, FormControl, Select, FormControlLabel, Switch, Box, InputLabel } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { getConfig } from "../config";

let appConfig = await getConfig();

export function CurrencyPicker({ reportingCurrency, setReportingCurrency }) {
  
  const handleChange = (event) => {
    setReportingCurrency(event.target.value);
  };

  return (
    <Box data-testid="currency-picker">
      <FormControl fullWidth>
        <InputLabel id="currency-label" shrink={true}>Currency</InputLabel>
        <Select
          id="currency-select"
          labelId="currency-label"
          label="Currency"
          value={reportingCurrency}
          onChange={handleChange}
          defaultValue={reportingCurrency}
          size="small"
          sx={{ 
            width: "150px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#000270",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#000270",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#000270",
            },
            borderRadius: "16px",
            "& .MuiSelect-icon": {
              color: "#000270",
            },
            "& .MuiInputLabel-root": {
              color: "#000270",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#000270",
            },
          }}
          IconComponent={ArrowDropDownIcon}
        >
          {appConfig.REPORTING_CURRENCIES.map((currency) => (
            <MenuItem key={currency} value={currency}>
              {currency}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export function FxTypePicker({ fxType, setFxType }) {

  const handleChange = (event) => {
    setFxType(event.target.value);
  };

  const fxTypeLabels = Object.keys(appConfig.CASHFLOW_FX_TYPE_MAP);

  return (
    <Box data-testid="fx-type-picker">
      <FormControl fullWidth size="small">
        <InputLabel id="fx-type-label" shrink={true}>Fx Type</InputLabel>
        <Select
          id="fx-type-select"
          labelId="fx-type-label"
          label="Fx Type"
          value={fxType}
          onChange={handleChange}
          defaultValue={fxType}
          variant="outlined"
          size="small"
          sx={{
            width: 150,
            borderRadius: "16px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#000270",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#000270",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#000270",
            },
            "& .MuiSelect-icon": {
              color: "#000270",
            },
            "& .MuiInputLabel-root": {
              color: "#000270",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#000270",
            },
          }}
        >
          {fxTypeLabels.map((label) => (
            <MenuItem key={label} value={label}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export function CashflowFlagsSwitch({flag, setFlag, label}) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={flag}
            onChange={(e) => setFlag(e.target.checked)}
            sx={{ ml: '16px' }}
          />
        }
        label={label}
      />
    </Box>
  );
}